import { NONPROFIT_DISCOUNT_RATE, applyNonprofitDiscount } from '../types';

import { html } from 'lit';
import { openChatWindow } from './intercom';

interface NonprofitNoteOptions {
    /** Per-month total for what's currently selected, in whole dollars. */
    monthlyTotal: number;
    /** Total actually charged each billing period, in whole dollars. */
    billedTotal: number;
    /** e.g. "annually" or "every 3 months". Omit for monthly billing, where it just repeats the monthly total. */
    billedPeriodLabel?: string;
    hasExistingSub?: boolean;
}

/** Shared so the cart and the upgrade dialog can't drift apart on discount copy. */
export function renderNonprofitDiscountNote(callsite: string, options: NonprofitNoteOptions) {
    const { monthlyTotal, billedTotal, billedPeriodLabel, hasExistingSub = false } = options;
    if (monthlyTotal <= 0) return '';

    const openNonprofitChat = () => openChatWindow(callsite, 'I am interested in Proxi for Non-Profits and Schools. Attached is my proof of status.');

    // Kept to one line so it doesn't dominate the cart; the figures live in the hover title.
    const detail = `You'd pay $${applyNonprofitDiscount(monthlyTotal)}/month${billedPeriodLabel ? ` — $${applyNonprofitDiscount(billedTotal)} billed ${billedPeriodLabel}` : ''}. ${
        hasExistingSub ? "We'll apply it to your next invoice." : "Start your trial now and we'll apply it before your first charge."
    }`;

    return html`
        <button
            type="button"
            class="link"
            style="cursor: pointer; background: none; border: none; padding: 0; margin: 0; font: inherit; color: inherit; text-align: inherit"
            title="${detail}"
            @click="${openNonprofitChat}"
        >
            Non-profits and K-12 schools get ${Math.round(NONPROFIT_DISCOUNT_RATE * 100)}% off.
            <span style="text-decoration: underline">Message us</span> with proof of status.
        </button>
    `;
}
